<template>
  <form class="entry-block__form form" action="#" @submit.prevent="submit">
    <div class="form__body">
      <Notice
        v-if="blockTime !== '0:00'"
        :text="` משתמש יקר, עקב נסיונות רבים של התחברות למערכת, הכניסה נחסמה למשך כ-
        ${blockTime}
        דקות`"
      />
      <Notice
        v-if="errorTime"
        :text="`יותר מדי ניסיונות התחברות. נסה שוב בעוד ${errorTime} שניות.`"
      />
      <Notice
        v-else-if="!blockError && errors != null && errors.password"
        :text="errors.password[0]"
      />
      <Notice
        v-else-if="!blockError && errors != null && errors.email"
        :text="errors.email[0]"
      />

      <div class="form__field form__field--w-icon-right">
        <div class="form__field-label">שם משתמש</div>
        <div class="form__field-icon">
          <icon name="user-icon" />
        </div>
        <input
          v-model="form.email"
          type="text"
          :class="'form__field-input email-input'"
          placeholder="דואר אלקטרוני"
        />
      </div>
      <div class="form__field form__field--password form__field--w-icon-right">
        <div class="form__field-label">סיסמה</div>
        <div class="form__field-icon">
          <icon name="user-pass-icon" />
        </div>
        <div
          class="form__field-password-btn"
          @click="password_type = !password_type"
        >
          <icon name="user-pass-see-icon" width="16" height="16" />
        </div>
        <input
          v-model="form.password"
          :type="password_type ? 'password' : 'text'"
          placeholder="הכנס סיסמתך"
          :class="
            'form__field-input' + (errors && errors.password ? ' error ' : '')
          "
        />
      </div>
      <div class="form__field">
        <label for="checkbox" class="checkbox">
          <input
            id="checkbox"
            v-model="form.remember"
            type="checkbox"
            class="checkbox__input"
          />
          <div class="checkbox__marker" />
          <div class="checkbox__text">השאר אותי מחובר</div>
        </label>
      </div>
    </div>
    <div class="form__footer">
      <simple-preloader v-if="submitted" class="ml-2 mt-0 mb-0" />
      <button
        v-if="blockTime !== '0:00' || errorTime"
        type="submit"
        class="btn btn--grey"
        disabled="disabled"
      >
        התחבר
      </button>
      <button v-else type="submit" class="btn btn--blue" :disabled="submitted">
        התחבר
      </button>
      <router-link :to="{ name: 'ForgotPassword' }" class="link">
        <span> שכחתי סיסמה </span>
      </router-link>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SimplePreloader from '@/Components/SimplePreloader';
export default {
  name: 'SignIn',
  components: { SimplePreloader },
  data() {
    return {
      form: {
        email: '',
        password: '',
        remember: ''
      },
      submitted: false,
      password_type: true,
      flag: false
    };
  },
  computed: {
    ...mapGetters({
      errors: 'auth/errors',
      errorTime: 'auth/errorTime',
      blockError: 'auth/getBlockError',
      blockTime: 'auth/blockTime'
    })
  },
  watch: {
    errorTime(newVal) {
      if (newVal === 60) {
        this.start();
      }
    }
  },
  mounted() {
    this.starBlock(true);
    if (!this.blockError && !this.flag) {
      if (
        localStorage.getItem('time') != 0 &&
        localStorage.getItem('time') != null
      ) {
        this.SET_BLOCK_TIME(this.timerBlock());
        this.starBlock();
      }
    }
    if (this.blockTime === '5:00') {
      this.starBlock();
    }
  },
  methods: {
    ...mapActions({
      signIn: 'auth/signIn',
      SET_LOGIN_FORM: 'auth/SET_LOGIN_FORM',
      SET_BLOCK_TIME: 'auth/SET_BLOCK_TIME'
    }),
    async submit() {
      this.submitted = true;
      this.SET_LOGIN_FORM(this.form);
      await this.signIn();
      this.submitted = false;
    },
    starBlock(clear) {
      const timer = setInterval(() => {
        if (clear) {
          clearInterval(timer);
        } else if (this.blockTime !== '0:00') {
          this.$store.commit('auth/SET_BLOCK_TIME_DEC');
        } else {
          clearInterval(timer);
        }
      }, 1000);
    },
    start() {
      const timer = setInterval(() => {
        if (this.errorTime > 0) {
          this.$store.commit('auth/SET_ERROR_TIME_DEC');
        } else {
          clearInterval(timer);
        }
      }, 1000);
    },
    timerBlock() {
      if (
        localStorage.getItem('time') !== '0:00' &&
        localStorage.getItem('time') !== null
      ) {
        let time = new Date() - new Date(localStorage.getItem('nowTime'));
        time = Math.ceil(time / 1000);
        if (time > 0 && time < 5 * 60 + 1) {
          let min = 0;
          let sec = '00';
          for (let i = 0; i < 5; i++) {
            if (time !== 0) {
              if (time >= 60) {
                time -= 60;
                min++;
              } else if (time < 60) {
                if (time < 10) {
                  sec = '0' + time;
                  time = 0;
                } else {
                  sec = time;
                  time = 0;
                }
              }
            }
          }
          const timer = localStorage.getItem('time').split(':');
          let minutes = parseInt(timer[0], 10);
          let seconds = parseInt(timer[1], 10);
          minutes = minutes - min > 0 ? minutes - min : 0;
          seconds = seconds - sec > 0 ? seconds - sec : '00';
          return minutes + ':' + seconds;
        }
        return '0:00';
      }
    }
  }
};
</script>

<style lang="scss">
main {
  height: 100%;
}

.error-notice svg {
  min-width: 24px;
}

.btn--grey:hover {
  background: #cfd3de;
  cursor: default;
}
.form__footer {
  position: relative;
  .lds-ring {
    position: absolute;
    right: -35px;
  }
}
</style>
